import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4cd687a2&scoped=true&"
import script from "./component.js?vue&type=script&lang=js&"
export * from "./component.js?vue&type=script&lang=js&"
import style0 from "./style.sass?vue&type=style&index=0&id=4cd687a2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd687a2",
  null
  
)

export default component.exports